export enum ShadowQuality {
  /**
   * Low quality (8-bit) shadows.
   */
  low  = "low",
  /**
   * Medium quality (16-bit) shadows.
   */
  medium = "medium",
  /**
   * High quality (32-bit) shadows.
   */
  high = "high"
}